<template>
 <div>
     <Head />
     <el-row :gutter="20">
         <el-col :span="4">
             <LeftBody />
         </el-col>
         <el-col :span="20">
             <RightBody />
         </el-col>
     </el-row>
     <Footer />
 </div>
</template>

<script>
// @ is an alias to /src
import Head from '@/components/Head.vue'
import Footer from '@/components/footer.vue'
import LeftBody from '@/components/leftBody.vue'
import RightBody from '@/components/contentUs.vue'

export default {
    name: 'HomeView',
    components: {
        Head,
        LeftBody,
        RightBody,
        Footer,
    }
}
</script>
